module.exports = __webpack_public_path__ + "static/TTNormsPro-Regular-5733ae5d93e5bd9d64fce3e7d95e20f7.woff2";